import api from './index'
// let default_lag = localStorage.getItem('locale_place') == 'zh' ? '2' : localStorage.getItem('locale_place') == 'en' ? '1' : '3'
// let select_lag = localStorage.getItem('dataLanguageId')
// let num = select_lag || default_lag
//获取数据
const getDocumentList = (params) => api.post('/article/list', {columnId:params,languageCode:1});
const getHeaderList = () => api.post('/column/list', {languageCode:1});
const getCaseList = (params) => api.post('/sub/list', {nid:params,languageCode:1});
const getCode = () => api.post('/contact/generate', null);
const getFooterList = () => api.post('/setup',{languageCode:1});
const getFormList = (params) => api.post('/contact/save', params);
export {
    getDocumentList,
    getHeaderList,
    getCaseList,
    getCode,
    getFormList,
    getFooterList
}


// WEBPACK FOOTER //
// ./src/api/api.js